export default "__VITE_ASSET__Y9YH1Z3D__"